import { defineComponent, inject, ref, provide, onMounted, watch, resolveComponent, openBlock, createElementBlock, unref, createBlock, createCommentVNode } from 'vue';
import { routeKey, pageKey, invokeKey, fetchPageBuilder, fetchPage } from '@drapejs/core';

var script = /*#__PURE__*/defineComponent({
  name: 'storyblok-global-block',

  setup(__props) {
    const route = inject(routeKey);
    const page = inject(pageKey, ref({}));
    const invoke = inject(invokeKey);
    const previewPage = ref({});
    provide(pageKey, previewPage);
    onMounted(reloadPreview);
    watch(page, (newValue, oldValue) => {
      if (newValue.previewPage !== oldValue.previewPage) {
        reloadPreview();
      }
    });

    async function reloadPreview() {
      if (page.value.previewPage && route) {
        const command = fetchPageBuilder(route.protocol, route.host, '/' + page.value.previewPage); // findByUuid is a custom fetchPage property for Storyblok connector, allowing us to fetch a story by UUID instead of path

        command.findByUuid = true;
        previewPage.value = await (invoke === null || invoke === void 0 ? void 0 : invoke(fetchPage, command));
      }
    }

    return (_ctx, _cache) => {
      const _component_blocks_repeater = resolveComponent("blocks-repeater");

      return openBlock(), createElementBlock("div", null, [unref(page).blocks ? (openBlock(), createBlock(_component_blocks_repeater, {
        key: 0,
        blocks: unref(page).blocks
      }, null, 8, ["blocks"])) : createCommentVNode("", true)]);
    };
  }

});

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Assign InstallableComponent type
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('StoryblokGlobalBlock', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { entry_esm as default };
